import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComputerMobileRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M4.028 3.688c0-.198.162-.36.36-.36h6.5c.2 0 .362.162.362.36v1.078h1.083V3.688c0-.793-.647-1.438-1.444-1.438h-6.5c-.797 0-1.445.645-1.445 1.438V7.28h-.866a.58.58 0 0 0-.578.575c0 1.272 1.034 2.3 2.311 2.3h3.467V9.078H3.81c-.499 0-.927-.294-1.12-.719h4.587V7.281h-3.25zm5.778 8.984a.36.36 0 0 1-.362-.36v-5.03c0-.198.163-.36.362-.36h2.527c.199 0 .361.162.361.36v5.03c0 .198-.162.36-.36.36zm0-6.828c-.797 0-1.445.644-1.445 1.437v5.032c0 .792.648 1.437 1.445 1.437h2.527c.797 0 1.445-.645 1.445-1.437V7.28c0-.793-.648-1.437-1.445-1.437zm.902 5.031a.539.539 0 1 0 0 1.078h.723a.539.539 0 1 0 0-1.078z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M1.5 2.25h13v11.5h-13z"
		})
	}) })]
});
export default SvgComputerMobileRegularIcon;
